// ブラウザでのファイルダウンロードヘルパー。
//
// 役割: 文字列/バイナリ（Uint8Array）を Blob 化し、一時的な <a download> をクリックして保存させる。
//       DOM に触れる薄いユーティリティで、UI 層（App）からのみ呼ぶ。
// 関係: layer-service.exportLayer が返す { filename, mime, data } をこれに渡してダウンロードする。
export function downloadFile(filename, data, mime = 'application/octet-stream') {
  const blob = new Blob([data], { type: mime })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
